import "../scss/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
import Slider from "./modules/Slider"
import Scroll from "./modules/scroll"

// Instantiate a new object using our modules/classes
var mobileMenu = new MobileMenu()
var slider = new Slider()
var scroll = new Scroll()